var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEykoCatalog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 2a1.505 1.505 0 011.383.914c.078.182.117.378.117.586v9a1.505 1.505 0 01-.914 1.383 1.472 1.472 0 01-.586.117H.75V2h14.5zM1.75 13h1V3h-1v10zm14-9.5a.48.48 0 00-.148-.352A.48.48 0 0015.25 3H3.75v10h11.5a.48.48 0 00.352-.148.48.48 0 00.148-.352v-9zm-9 1.5h6v3h-6V5zm1 2h4V6h-4v1z",
    fill: "currentColor"
  })));
}

export default SvgEykoCatalog;